export default __webpack_public_path__ + "static/media/CommandandConquerseries.7cfe0e77.jpg";